/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import React, { useState } from "react";
import { CircularProgress, Grid, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { ChecklistItem, Effect, Setter } from "../../utils/Interfaces";
import { updateTechnicianChecklistItem } from "../../features/tech-work-order/technicianWorkOrderFunctions";
import { useAppDispatch } from "../../app/hooks";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";

export interface MobileTechnicianChecklistItemProps {
    checklistItem: ChecklistItem;
    readonly: boolean;
    onUpdatedChecklistItem: Setter<Effect>;
}

const MobileTechnicianChecklistItem = (props: MobileTechnicianChecklistItemProps) => {
    const { checklistItem, readonly, onUpdatedChecklistItem } = props;
    const dispatch: Dispatch<AnyAction> = useAppDispatch();
    const [state, setState] = useState<number>(checklistItem.status);
    const [loading, setLoading] = useState<boolean>(false);

    const idKey: string = checklistItem.label.toLowerCase().replaceAll(/\W/g, "");

    return (
        <Grid xs={12} container sx={{ height: "100%", mb: 3 }}>
            <Grid xs={loading ? 7 : 8} item>
                <Stack direction="column" justifyContent="center" sx={{ height: "100%" }}>
                    <Typography>{checklistItem.label}</Typography>
                </Stack>
            </Grid>
            {loading && (
                <Grid xs={1} item>
                    <Stack direction="row" justifyContent="center">
                        <Stack direction="column" justifyContent="center">
                            <CircularProgress size={20} sx={{ mt: 1 }} />
                        </Stack>
                    </Stack>
                </Grid>
            )}
            <Grid xs={4} item>
                <TextField
                    disabled={loading || readonly}
                    id={idKey}
                    name={idKey}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setLoading(true);
                        let newValue: number = parseInt(event.target.value) as number;
                        setState(newValue);
                        updateTechnicianChecklistItem(checklistItem.id, dispatch, newValue, () =>
                            onUpdatedChecklistItem(() => {
                                setLoading(false);
                            })
                        );
                    }}
                    value={state}
                    size="small"
                    label={checklistItem.label}
                    select
                    fullWidth
                >
                    <MenuItem value={3}>Not Selected</MenuItem>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                    <MenuItem value={2}>N/A</MenuItem>
                </TextField>
            </Grid>
        </Grid>
    );
};

export default MobileTechnicianChecklistItem;
